import axios from 'axios';
import Config from '../../misc/Config';

const API_URL = Config.GFU_API_URL + '/auth';

const state = {
    prevTargetUrl: null,
    prevTargetHash: null,
    username: null,
    token: null,
    lastLogin: null,
};
const getters = {
    prevTargetUrl: (state) => state.prevTargetUrl,
    prevTargetHash: (state) => state.prevTargetHash,
    username: (state) => state.username,
    token: (state) => state.token,
    lastLogin: (state) => state.lastLogin,
};
const actions = {
    async login({ commit }, credentials) {
        const response = await axios.post(API_URL + '/login', credentials);
        commit('setUser', response.data);
    },
    async logout({ commit }) {
        await axios.get(API_URL + '/logout');
        commit('setUser', {
            email: null,
            token: null,
            lastLogin: null
        });
    }
};
const mutations = {
    setTargetUrl: (state, url) => state.prevTargetUrl = url,
    setTargetHash: (state, hash) => state.prevTargetHash = hash,
    setUser: (state, {email, token, lastLogin}) => {
        state.username = email
        state.token = token,
        state.lastLogin = new Date(lastLogin)
    }
};

export default {
    state,
    getters,
    actions,
    mutations,
}